const formats = [
  { icon: 'ri-calendar-check-line', title: 'Корпоративный тренинг', desc: 'Практическая программа для управленческой команды: диагностика, инструменты, разбор реальных ситуаций и отработка переговоров.' },
  { icon: 'ri-stack-line', title: 'Модульная программа', desc: 'Несколько модулей с практикой между встречами. Руководители применяют инструменты в работе и возвращаются для разбора.' },
  { icon: 'ri-sword-line', title: 'Переговорные дуэли', desc: 'Интенсивная отработка конкретных переговорных ситуаций один на один с разбором результата.' },
  { icon: 'ri-gamepad-line', title: 'Бизнес-игры', desc: 'Моделирование сложных управленческих и деловых ситуаций с высокой вовлечённостью.' },
  { icon: 'ri-user-voice-line', title: 'Индивидуальный коучинг', desc: 'Работа руководителя с конкретными переговорами и управленческими задачами: подготовка и разбор.' },
  { icon: 'ri-phone-line', title: 'Сопровождение', desc: 'Разбор реальных переговоров и сложных ситуаций после обучения, поддержка внедрения инструментов.' },
];

export default function FormatsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Форматы обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Как развивать переговорные компетенции руководителей — формат подбирается под задачу компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {formats.map((f) => (
            <div key={f.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${f.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{f.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}